module.exports = __webpack_public_path__ + "img/face-kiss-wink-heart.89e4d75d.svg";